import { render } from "./TabOrderHistory.vue?vue&type=template&id=236c0166"
import script from "./TabOrderHistory.vue?vue&type=script&lang=js"
export * from "./TabOrderHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__